'use client';

import { RootState } from '@/store/store';
import { IEmployer } from '@/types';
import { Brand } from '@/types/Brand';
import { createSlice } from '@reduxjs/toolkit';

interface SteState {
  societe: IEmployer;
  brand?: Brand;
}

const initialState: SteState = {
  societe: {
    id: '',
    siren: '',
    name: '',
    tag: '',
    ou: '',
    employer_type: 'COMPANY',
    authn_method: 'LOCAL',
    api_organization_id: '',
  },
  brand: undefined,
};

export const steSlice = createSlice({
  name: 'ste',
  initialState,
  reducers: {
    update: (state, newPartState) => {
      state.societe = { ...state.societe, ...newPartState?.payload?.societe };
      state.brand = newPartState?.payload?.brand ?? state.brand;
    },
    setSte: (state, selected) => {
      state.societe = selected.payload;
    },
    clearSte: (state) => {
      state.societe = {
        id: '',
        siren: '',
        name: '',
        tag: '',
        ou: '',
        employer_type: 'COMPANY',
        authn_method: 'LOCAL',
        api_organization_id: '',
      };
    },
    clearBrand: (state) => {
      state.brand = undefined;
    },
  },
});

export const { setSte, clearSte, update, clearBrand } = steSlice.actions;
export const selectSte = (state: RootState) => state.selectedSte.societe;
export default steSlice.reducer;
